import './footer.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Footer = forwardRef((props, ref) => {
  const className = classNames({
    footer: true,
    [props.className]: props.className,
  });

  return (
    <footer ref={ref} className={className}>
      {props.children}
    </footer>
  );
});

Footer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Footer;
